module.exports = __webpack_public_path__ + "img/address-foreign-mobile-2.0ce0de4e.svg";